const getClosestOrgLikeTeamId = (store, teamId) => {
  const team = store.getters.teamById(teamId)
  if (!team) return null
  else if (team.isOrgLike) return team.id
  return getClosestOrgLikeTeamId(store, team.parentId)
}

export default getClosestOrgLikeTeamId
